import { map } from 'lodash'
import { forwardRef, useMemo } from 'react'
import { graphql, useFragment } from 'react-relay'

import { type VaccinationStatusesMultiSelectInput_query$key } from '@/__generated__/VaccinationStatusesMultiSelectInput_query.graphql'
import { MultiSelectInput, type MultiSelectInputProps, type MultiSelectInputRef, type SelectOption } from '@/components'

export type VaccinationStatusesMultiSelectInputProps = Omit<MultiSelectInputProps, 'options'> & {
  queryRef: VaccinationStatusesMultiSelectInput_query$key | null | undefined
}

export const VaccinationStatusesMultiSelectInput = forwardRef<
  MultiSelectInputRef,
  VaccinationStatusesMultiSelectInputProps
>(({ queryRef, ...props }, ref) => {
  const queryData = useFragment(
    graphql`
      fragment VaccinationStatusesMultiSelectInput_query on Query {
        vaccinationStatuses(orderBy: [SEQUENCE_ASC]) {
          nodes {
            name
            rowId
          }
        }
      }
    `,
    queryRef
  )

  return (
    <MultiSelectInput
      options={useMemo<SelectOption[]>(
        () =>
          map(queryData?.vaccinationStatuses?.nodes, (vaccinationStatus) => ({
            label: vaccinationStatus!.name,
            value: vaccinationStatus!.rowId
          })),
        [queryData?.vaccinationStatuses?.nodes]
      )}
      ref={ref}
      {...props}
    />
  )
})

VaccinationStatusesMultiSelectInput.displayName = 'VaccinationStatusesMultiSelectInput'
